import type { ComponentProps, ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { useFieldContext, useFormReadOnly, FieldInfo, hasFieldError } from './shared'
import { Checkbox } from '../../ui/checkbox'
import { Label } from '../../ui/label'

export function CheckboxField({
  label,
  acceptIndeterminate,
  className,
  ...props
}: ComponentProps<'button'> & { label?: ReactNode; acceptIndeterminate?: boolean }) {
  const field = useFieldContext<boolean | null>()
  const formReadOnly = useFormReadOnly()
  const isReadOnly = props.disabled ?? formReadOnly

  return (
    <div>
      <div className={cn('text-muted-foreground flex items-start gap-4', className)}>
        <Checkbox
          id={field.name}
          name={field.name}
          aria-invalid={hasFieldError(field.state.meta)}
          checked={field.state.value ?? 'indeterminate'}
          onBlur={field.handleBlur}
          onCheckedChange={() => {
            if (acceptIndeterminate) {
              field.handleChange(field.state.value === false ? true : field.state.value === true ? null : false)
            } else {
              field.handleChange(!field.state.value)
            }
          }}
          {...props}
          disabled={isReadOnly}
          className={cn(isReadOnly && 'opacity-100')}
        />
        {label && (
          <Label
            data-slot="form-label"
            data-error={hasFieldError(field.state.meta)}
            className="data-[error=true]:text-destructive"
            htmlFor={field.name}
          >
            {label}
          </Label>
        )}
      </div>
      <FieldInfo fieldState={field.state} />
    </div>
  )
}
